import Vue from 'vue'
import VueRouter from 'vue-router'
// import LAYOUT from '@/layouts/layout.vue'
// import Main from '@/components/Main'

const LAYOUT = () => import('@/layouts/layout.vue')
const Home = () => import('@/views/Home')
const SignIn = () => import('@/views/login.vue')
const Register = () => import('@/views/register.vue')
const ForgotPassword = () => import('@/views/forgotPassword.vue')

// import usersList from '@/components/Customers/usersList'
// import testingReqList from '@/components/customers/testingReqList'
// import sampleList from '@/components/customers/sampleList'
//<import>
Vue.use(VueRouter)

const routes = [
  {
    path: '/http*',
    beforeEnter: (to) => {
      console.log(to.fullPath.substring(1))
      window.location.replace(to.fullPath.substring(1), '_blank')
    }
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register
  },
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/',
    // name: 'layout',
    component: LAYOUT,
    children: [
      {
        path: '',
        name: 'Main',
        component: Home
      },
      {
        path: 'about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/servicelist',
        name: 'servicelist',
        component: () => import('@/views/serviceList')
      },
      {
        path: '/customers/usersList',
        name: 'customers_usersList',
        component: () => import('@/components/customers/usersList')
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/components/customers/usersProfile')
      },
      {
        path: 'vw_requestList',
        name: 'vw_requestList',
        component: () => import('@/components/customers/vw_requestList')
      },
      {
        path: 'req',
        name: 'req',
        component: () => import('@/views/req')
      },
      {
        path: '/reqFZ/:id?/:curr?',
        name: 'reqFZ',
        component: () => import('@/views/reqFZ')
      },
      {
        path: 'reqFZ',
        name: 'reqFZ',
        component: () => import('@/views/reqFZ')
      },
      {
        path: 'visitorForm',
        name: 'visitorForm',
        component: () => import('@/views/visitorForm')
      },
      {
        path: '/customers/testingReqList',
        name: 'customers_testingReqList',
        component: () => import('@/components/customers/testingreqList')
      },
      {
        path: '/customers/sampleList',
        name: 'customers_sampleList',
        component: () => import('@/components/customers/sampleList')
      }
      // {
      //     path: '/customers/vw_requestList',
      //     name: 'vw_requestList',
      //     component: () =>
      //         import ('@/components/customers/vw_requestList')
      // }
      //<router>
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.VUE_APP_ROOT_PATH
})

export default router
